// Constants
import { ERROR_MODAL_OPEN, ERROR_MODAL_CLOSE } from './errorModalConstants';

export const errorModalOpen = ({ modalId, data = undefined }) => ({ type: ERROR_MODAL_OPEN, modalId, data });
export const errorModalClose = () => ({ type: ERROR_MODAL_CLOSE });
